module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAJ2AAACdgBx6C5rQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAD9SURBVEiJtdYxCsIwFAbgP9IUV6GDV+jSxQsUQQd1cfEObkLxFC5u3sHFoSqo6ODepYtH0M1VSUqdRGwrJunr2woNHyHv/QnrriYpFGo/nDOV/7JVM1mkU1bm+2IJ3t6OZjcq4LODFDEAV1pi54eBQw5w++kDLAKDZ8vk3FtOm6TAZrC4c/7oACwC4EouThTI1yFXgeS6iBopbFNK5OccUCF/p7O/HjeEqB+AtAWDOVEa/zKIcr6YIloBZoJoJ6Qq8k5p7TTV7S6juNZBjO8DVaTUhaOCGF2D2So6eMnFlQwAAD8MHFskRzB4SBGDwSMFgNxOUApQfY1U/qp4AWFws2TPEKVdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./resources/images/a-resize_with-green.png
// module id = 2276
// module chunks = 0